import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useDeletePhoto(sessionId: string) {
  return useMutation(
    trpcOptions.app.deletePhoto.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }),
  )
}
